import Mock from "../mock";

const database = {
  information: {
    name: 'Carrie Lee',
    aboutContent: "I lead product design for high-stakes industries - adtech, fintech, medtech - where getting the UX wrong costs real money. My toolkit spans data analysis, content strategy, and user research, across B2B and B2C on desktop and mobile.",
    age: '',
    voice: '312.869.2856',
    country: 'USA',
    language: 'English',
    email: 'cal@calee.me',
    address: 'Joliet, Illinois',
    freelanceStatus: 'January 2025',
    socialLinks: {
      facebook: '',
      twitter: '',
      pinterest: '',
      behance: '',
      linkedin: 'https://www.linkedin.com/in/carrieleedesigns/',
      dribbble: '',
      github: 'https://github.com/calee1/'
    },
    brandImage: '/images/brand-image.jpg',
    cvfile: '/files/LeeCA-resume.pdf'
  },
  services: [
    {
      title: "Design",
      icon: 'pallet',
      details: "Product design including wireframing, prototyping, content strategy and management as well as requirement gathering, competitive and user research and usability testing."
    },
    {
      title: "Data Analysis",
      icon: 'user',
      details: "Bringing data from raw to ready - data gathering, cleansing, processing, manipulating, visualizing and interpreting. Python analytics beginner with NumPy and Pandas."
    },
    {
      title: "Development",
      icon: 'code',
      details: "Front-end coding including design tokens, HTML, CSS, JavaScript as well as C#, SQL and XML in Agile environment. Beginner with Grafana, React and Node.js."
    }
  ],
  reviews: [
    {
      id: 1,
      content: "Carrie has been a pleasure to work with and a solid contribution to the team, even with swiftly changing requirements and demanding partners.",
      author: {
        name: 'Mary Henick',
        designation: 'Product owner'
      }
    },
    {
      id: 2,
      content: "Carrie has a great depth of understanding around designing UX. She cares deeply about the user's needs and works hard to make tasks easier.",
      author: {
        name: 'Steve Travis',
        designation: 'Former manager'
      }
    },
    {
      id: 3,
      content: "I would highly recommend Carrie to any team looking to get a clean expression of the user experience for their product",
      author: {
        name: 'Mitch Shiver',
        designation: 'Former manager'
      }
    },
    {
      id: 4,
      content: "Teaming up with Carrie and having her as a lead has been a great learning experience for my professional career. One of her greatest assets is her empathy.",
      author: {
        name: 'Maria Laura Ponti',
        designation: 'Direct report'
      }
    }
  ],
  skills: [
    {
      title: "Figma, Axure, Sketch, InVision, Claude",
      value: 95
    },
    {
      title: "Adobe Suite, G Suite, MS Suite, Confluence",
      value: 95
    },
    {
      title: "Miro, Mural, Lucid, Notion",
      value: 90
    },
    {
      title: "HTML5, CSS3",
      value: 90
    },
    {
      title: "Claude Code, Figma MCP, GSAP, JavaScript, jQuery",
      value: 70
    },
    {
      title: "node.js, ReactJS, Python, NumPy, Pandas",
      value: 60
    }
  ],
  portfolios: [
    {
      id: 1,
      title: "Engineering Platform",
      subtitle: "Led app-centric design effort for an internal development platform from initial discovery and wireframing through usability testing and detailed specification writing for pixel-perfect UI implementation. (2024)",
      imageUrl: "/images/portfolio-image-1.jpg",
      largeImageUrl: [
        "/images/portfolio-image-1-lg.jpg",
        "/images/portfolio-image-1-lg2.jpg",
        "/images/portfolio-image-1-lg3.jpg"
      ]
    },
    {
      id: 2,
      title: "Retail Data Analytics",
      subtitle: "Brought design thinking and leadership to a large grocery chain's data anlytics effort in exporting loyalty data, as well as reimagining the user experience around creating product groups and assigning product attributes. (2024)",
      imageUrl: "/images/portfolio-image-2.jpg",
      largeImageUrl: [
        "/images/portfolio-image-2-lg.jpg",
        "/images/portfolio-image-2-lg2.jpg",
        "/images/portfolio-image-2-lg3.jpg"
      ]
    },
    {
      id: 3,
      title: "Expense Management",
      subtitle: "Working as design lead at an HR services company, I modernized an expense reporting application with streamlined workflows for both company administrators and employees on both desktop and mobile. (2023) ",
      imageUrl: "/images/portfolio-image-3.jpg",
      largeImageUrl: [
        "/images/portfolio-image-3-lg.jpg",
        "/images/portfolio-image-3-lg2.jpg",
        "/images/portfolio-image-3-lg3.jpg"]
    },
    {
      id: 4,
      title: "Consumer Banking",
      subtitle: "Project for new, mobile-first design pattern - a bottom drawer with a consistent call to action for cross-usage across divisions of the bank's public site starting with Home Lending. (2021)",
      imageUrl: "/images/portfolio-image-4.jpg",
      largeImageUrl: ["/images/portfolio-image-4-lg.jpg"]
    },
    {
      id: 5,
      title: "Enterprise SaaS",
      subtitle: "Project to design and test a reusable pattern library to be used across a suite of enterprise software products for email security and brand management including data analysis. (2019)",
      imageUrl: "/images/portfolio-image-5.jpg",
      largeImageUrl: [
        "/images/portfolio-image-5-lg.jpg",
        "/images/portfolio-image-5-lg2.jpg"]
    },
    {
      id: 6,
      title: "Radiology",
      subtitle: "Project for FDA-approved, web-based, radiology software. From market-based needs research to usability testing and detailed specifications for final, development and testing. (2016)",
      imageUrl: "/images/portfolio-image-6.jpg",
      largeImageUrl: ["/images/portfolio-image-6-lg.jpg"]
    },
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "2025 to Present",
        position: "Lead Design Consultant",
        company: "Basis, Chicago, IL",
        details: "Currently working as senior designer in adtech."
      },
      {
        id: 2,
        year: "2024 to 2025",
        position: "Lead Design Consultant",
        company: "Chicagoland, IL",
        details: "Worked as UX design consultant, leading end-to-end design projects with full-stack design from user research to user acceptance and everything in between on projects in health care, retail data analytics and food safety regulations."
      },
      {
        id: 3,
        year: "2022 to 2023",
        position: "Lead UX Designer",
        company: "TriNet, Dublin, CA",
        details: "Successfully led a cross-functional team to deliver outstanding UX for the company's financial services portfolio; including responsive web and native mobile applications (iOS and Android) for Expense Management, Payroll and Time & Attendance."
      },
      {
        id: 4,
        year: "2022",
        position: "Senior UX Designer",
        company: "Kentik, San Jose, CA",
        details: "Led end-to-end UX activities for Alerting, Trends, Insights and Data Shares for the Core module of a B2B network observability platform."
      },
      {
        id: 5,
        year: "2019 to 2021",
        position: "Lead UX Designer",
        company: "Wells Fargo, Oakland, CA",
        details: "I led design activities for a new mobile-first design system pattern for home loan applications as well as streamlined workflows for claims submissions utilizing machine-learning and AI."
      }
    ],
    educationExperience: [
      {
        id: 1,
        year: "San Francisco, CA",
        graduation: "Certified User Experience Analyst",
        university: "Human Factors International",
        details: "2015"
      },
      {
        id: 2,
        year: "Chicago, IL",
        graduation: "M.S., Human-Computer Interaction",
        university: "DePaul University",
        details: ""
      },
      {
        id: 3,
        year: "Peoria, IL",
        graduation: "B.S., Communication & Psychology",
        university: "Bradley University",
        details: ""
      }
    ]
  },
  blogs: [
    {
      id: 1,
      title: 'Sample',
      featuredImage: '/images/blog-image-1.jpg',
      filesource: '../../blog/markdown-html-supported-blog.md',
      createDay: "1",
      createMonth: 'January',
      createYear: "2024"
    },
  ],
  contactInfo: {
    phoneNumbers: ['312.869.2856'],
    emailAddress: ['cal@calee.me'],
    address: "Joliet, Illinois"
  },
  aiProjects: [
    {
      id: 1,
      title: "caleewaves",
      category: "Audio Visual",
      description: "Audio-reactive music visualizer powered by Web Audio API and GSAP. Made with v0.",
      url: "https://v0-caleewaves.vercel.app/"
    },
    {
      id: 2,
      title: "Music Visualizer (Drive)",
      category: "Audio Visual",
      description: "Music visualizer powered by Web Audio API. Made with v0.",
      url: "https://v0-drive-nine.vercel.app"
    },
    {
      id: 3,
      title: "Music Visualizer (Upload)",
      category: "Audio Visual",
      description: "Audio-reactive music visualizer — upload your own tracks. Made with Cursor.",
      url: "https://calee.me/waves-cursor"
    },
    {
      id: 4,
      title: "UX Design Glossary",
      category: "UX",
      description: "A comprehensive design terminology reference built with AI. Made with v0.",
      url: "https://uxglossary.vercel.app"
    },
    {
      id: 5,
      title: "Usability Analysis Agent",
      category: "UX",
      description: "A concept for AI-driven heuristic evaluations. Made with Claude.",
      url: "https://claude.ai/public/artifacts/880fb79e-2734-46fa-9d08-09aa7e64c51e"
    },
    {
      id: 6,
      title: "USA Map",
      category: "Data Visual",
      description: "An interactive USA cannabis map visualization. Made with v0.",
      url: "https://usacannamap.vercel.app"
    },
    {
      id: 7,
      title: "Design System: calee.me",
      category: "Design Systems",
      description: "Full design token and component documentation built with Claude Code.",
      url: "/design-system/"
    },
    {
      id: 8,
      title: "Design System: Ember",
      category: "Design Systems",
      description: "A complete design system and component library — Ember theme. Made with Lovable.",
      url: "https://emberglow-design-suite.lovable.app"
    },
    {
      id: 9,
      title: "Design System: Violet",
      category: "Design Systems",
      description: "A complete design system and component library — Violet theme. Made with Lovable.",
      url: "https://violet-core-design.lovable.app"
    },
    {
      id: 10,
      title: "Music Balls - Demo Project",
      category: "Animation",
      description: "GSAP animation project bouncing balls to music. Made with Cursor.",
      url: "https://calee.me/project1/"
    },
    {
      id: 11,
      title: "Ball Test - Demo Project",
      category: "Animation",
      description: "GSAP animation project bouncing balls. Made with Cursor.",
      url: "https://calee.me/project2/"
    }
  ]
}

Mock.onGet("/api/information").reply((config) => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply((config) => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply((config) => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply((config) => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply((config) => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply((config) => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply((config) => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply((config) => {
  const response = database.contactInfo;
  return [200, response];
});

Mock.onGet("/api/aiprojects").reply((config) => {
  const response = database.aiProjects;
  return [200, response];
});
